import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { ListDealerAction } from '../../redux/actions/DealerAction'
import { toggleFullScreen } from '../layout/functions/layout'
import Loader from '../layout/Loader'

const ListDealerTable = ({ nav }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const userLogin = useSelector(state => state.userSignIn)
    const { userInfo } = userLogin
    const list = useSelector((state) => state.listDealer)
    const { loading, success, dealer } = list
    const [searchTerm, setSearchTerm] = useState('')
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')

    useEffect(() => {
        if (!userInfo) {
            navigate('/sign-in')
        }
        toggleFullScreen(nav = { nav })
    }, [userInfo, navigate]);

    
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm)
        }, 500) 

        return () => clearTimeout(timer)
    }, [searchTerm])

    useEffect(() => {
        if (userInfo?.token) {
            dispatch(ListDealerAction(userInfo.token, debouncedSearchTerm))
        }
    }, [dispatch, userInfo?.token, debouncedSearchTerm])

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value)
    }

    return (
        <>
            <div className="card">
                <div className="card-body">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <h5 className="mb-0">Dealers List</h5>
                        <form className="ms-auto position-relative" style={{ minWidth: '300px' }}>
                            <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                <i className="bi bi-search" />
                            </div>
                            <input
                                className="form-control ps-5"
                                type="text"
                                placeholder="Search by Company, Phone, or Email"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                style={{ minWidth: '300px' }}
                            />
                        </form>
                    </div>
                    <div className="table-responsive mt-3">
                        <table className="table align-middle">
                            <thead className="table-secondary">
                                <tr>
                                    <th>Company</th>
                                    <th>Name</th>
                                    <th>Phone#</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="4" className="text-center py-4">
                                            <Loader />
                                        </td>
                                    </tr>
                                ) : dealer && dealer.length > 0 ? (
                                    dealer.map((d) => (
                                        <tr key={d._id}>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <Link 
                                                        to={`/dealer/view-dealer/${d._id}`}
                                                        className="text-decoration-none"
                                                    >
                                                        <p className="mb-0 text-primary cursor-pointer">
                                                            {d.companyName}
                                                        </p>
                                                    </Link>
                                                </div>
                                            </td>
                                            <td>{d.name}</td>
                                            <td>
                                                <a 
                                                    href={`tel:${d.phone}`}
                                                    className="text-decoration-none"
                                                >
                                                    {d.phone}
                                                </a>
                                            </td>
                                            <td>{d.email}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center py-4">
                                            {searchTerm ? 
                                                `No dealers found matching "${searchTerm}"` : 
                                                'No dealers found'
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ListDealerTable